import React from 'react';

import { HelmetTags, MainLayout } from '~/components';

import type { Content } from './types';

import { ArticlePageContent } from './ArticlePageContent';

type PageViewData = React.ComponentProps<typeof MainLayout>['pageViewData'];

interface Props {
  content: Content;
}

export const ArticlePage: React.FC<Props> = ({ content }) => {
  const {
    title,
    seo_title,
    seo_description,
    entry_type,
    id,
    short_summary,
    entry_date,
    channel,
    topic,
    teacher,
    media_duration,
    full_url,
    no_text_image: { processed_url },
  } = content;

  const pageViewData: PageViewData = {
    contentAuthor: teacher.full_name,
    contentChannel: channel.name,
    contentTopic: topic.name,
    contentPubDate: entry_date.yyyymmdd,
    contentTitle: title,
    contentId: id,
  };
  return (
    <MainLayout pageViewData={pageViewData} pageTitle={title}>
      <HelmetTags
        entry_type={entry_type}
        teacherName={teacher.full_name}
        short_summary={short_summary}
        title={title}
        seo_title={seo_title}
        seo_description={seo_description}
        entry_date={entry_date}
        media_duration={media_duration}
        url={full_url}
        image_url={processed_url}
      />
      <ArticlePageContent content={content} />
    </MainLayout>
  );
};
